export const subscriptionListVideo = () => {
    const $subscriptionListVideo = document.querySelector(
        ".subscription-list-video"
    );
    if ($subscriptionListVideo) {
        const $wrapper = $subscriptionListVideo.querySelector(
            ".subscription-list-video__wrapper"
        );

        if ($wrapper) {
            const $wrapperVideo = $wrapper.querySelector(".wrapper__video");
            if ($wrapperVideo) {
                const $videoVideo = $wrapperVideo.querySelector(".video__video");
                const $videoIcon = $wrapperVideo.querySelector(".video__icon");

                if ($videoIcon && $videoVideo) {
                    $videoVideo.addEventListener("click", (event) => {
                        if ($videoVideo.paused || $videoVideo.ended) {
                            $videoIcon.classList.add("hidden");
                            $videoVideo.play();
                        } else {
                            $videoIcon.classList.remove("hidden");
                            $videoVideo.load();
                        }
                    });
            
                    $videoVideo.addEventListener("paused", (event) => {
                        $videoIcon.classList.remove("hidden");
                        $videoVideo.load();
                    });
                    $videoVideo.addEventListener("ended", (event) => {
                        $videoIcon.classList.remove("hidden");
                        $videoVideo.load();
                    });
                }
            }
        }
    }
};

export default subscriptionListVideo;